import redirect from "./redirect";

import { ApiError, ApiTellUser } from "../../core-module/services/error";

import store from "../../store"
import { showAlert } from "../../core-module/services/errorAlert/reducers"

export async function digestHTTPrespondeCode(res) {
  //Return Boolean. If true, ressource is available. If false, no.

  if (res.status === 401) {
    /*
    API answered with:
      -Don't know you (no token)
      -Don't trust you (token but something is wrong)
      -Please rekey

    So client need to:


    Grab new /k/ -- Carefull with race condition. Maybe give a sleep before releasing jrrbusy just in case
    READ identity res.
    If AuthStatus is not "OK"
      Delete loggedin file
      If on foreground
        Redirect to Auth page
    Else
      Grab new JRR with privinterface

    */
    redirect();
  } else if (res.status === 432) {
    /*
      Api telling client he is logged out
      Delete loggedin file
      If on foreground
        Redirect to Auth page
    */
    redirect();

    return false;
  } else if (res.status === 433) {
    /*
      Api telling client he needs to refresh password

      If on foreground
        Redirect to Auth page with refresh password
    */

    return false;
  } else if (res.status === 434) {
    /*
      Api telling client he needs to refresh u2f

      If on foreground
        Redirect to Auth page with refresh u2f
    */

    return false;
  } else if (res.status === 435) {
    /*
      Api telling client he needs to refresh password AND u2f

      If on foreground
        Redirect to Auth page with refresh  password AN u2f
    */

    return false;
  } else if (res.status === 450) {
    /*
      Api stopped execution with ExceptionAndTellUser
      Build message to tell customer what was the call and what was the response

      If on foreground
        Alert
      Else
        Notification

      Kill the request on queue (? almost sure about )
    */
    const resData450 = await res.json();
    throw new ApiTellUser(resData450.message);
  } else if (res.status === 500) {
    /*
      Api stopped execution with ExceptionAndMailAdmin or other error
      Generic message telling user it didn't work

      If on foreground
        Alert
      Else
        Notification

      DO NOT ! ! ! Kill the request on queue. Want to resubmit request


    */
    throw new ApiError("Server error 500");
  } else if (res.status === 404) {
    store.dispatch(showAlert("Server error 404"))
  } else if (res.status === 200) {
    return true;
  } else {
    throw new Error("Unknown API HTTP error");
  }
}
